import { render } from "./EditAssetPage2.vue?vue&type=template&id=f12294dc&scoped=true"
import script from "./EditAssetPage2.vue?vue&type=script&lang=js"
export * from "./EditAssetPage2.vue?vue&type=script&lang=js"

import "./EditAssetPage2.vue?vue&type=style&index=0&id=f12294dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12294dc"]])

export default __exports__